import React from 'react';
import { motion } from 'framer-motion';
import { trackPixelEvent } from '../lib/metaPixel';
interface PricingCardsProps {
  className?: string;
}
export function PricingCards({
  className = ''
}: PricingCardsProps) {
  return <div className={`grid md:grid-cols-2 gap-6 max-w-5xl mx-auto ${className}`} data-id="element-171">
      {/* Standard Plan */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="bg-bg-card border border-border-subtle rounded-xl p-8 flex flex-col" data-id="element-172">
        <div className="bg-bg-input border border-border-subtle rounded-full px-4 py-2 inline-block mb-6 self-start" data-id="element-173">
          <span className="text-sm font-semibold text-text-primary" data-id="element-174">
            📘 EFECTO IMÁN
          </span>
        </div>
        <h3 className="text-2xl font-bold text-text-primary mb-2" data-id="element-175">
          3 Módulos + 5 Bonos
        </h3>
        <p className="text-text-secondary mb-8" data-id="element-176">
          Ideal para: Hombres que quieren el sistema base
        </p>
        <div className="mb-8 mt-auto" data-id="element-177">
          <p className="text-red-strike line-through text-xl mb-1" data-id="element-178">$51.000</p>
          <p className="text-text-gold text-5xl font-black" data-id="element-179">
            $19.990{' '}
            <span className="text-lg text-text-secondary font-normal" data-id="element-180">ARS</span>
          </p>
        </div>
        <a href="https://librofy-store.myshopify.com/cart/47909760106717:1" target="_top" rel="noopener" onClick={() => trackPixelEvent('InitiateCheckout', {
        content_name: 'EFECTO IMÁN',
        value: 19990,
        currency: 'ARS'
      })} className="w-full bg-transparent border-2 border-gold-primary text-text-gold font-bold text-base py-4 px-6 rounded-md hover:bg-gold-primary/10 transition-all uppercase text-center block" data-id="element-181">
          → QUIERO EL EFECTO IMÁN
        </a>
      </motion.div>

      {/* Featured Plan */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className="bg-bg-card border-2 border-gold-primary rounded-xl p-8 relative shadow-gold-glow flex flex-col" data-id="element-182">
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold-primary text-black px-3 py-1 rounded text-[11px] font-bold tracking-wider" data-id="element-183">
          MÁS POPULAR
        </div>
        <div className="bg-bg-input border border-gold-subtle rounded-full px-4 py-2 inline-block mb-6 self-start" data-id="element-184">
          <span className="text-sm font-semibold text-text-primary" data-id="element-185">
            🏆 CÓDIGO ACELERADO ⭐
          </span>
        </div>
        <h3 className="text-2xl font-bold text-text-primary mb-2" data-id="element-186">
          3 Módulos + 5 Bonos + 20 Casos reales
        </h3>
        <p className="text-text-secondary mb-8" data-id="element-187">
          Ideal para: Hombres que quieren resultados más rápidos
        </p>
        <div className="mb-8 mt-auto" data-id="element-188">
          <p className="text-red-strike line-through text-xl mb-1" data-id="element-189">$69.000</p>
          <p className="text-text-gold text-5xl font-black" data-id="element-190">
            $27.990{' '}
            <span className="text-lg text-text-secondary font-normal" data-id="element-191">ARS</span>
          </p>
        </div>
        <a href="https://librofy-store.myshopify.com/checkouts/cn/hWNDC2YhgQFxT6QjxhxL0tCE/es-ar?_r=AQABaMWEh2_MnS_qSPgGn5hiRubNit4fMT9glsLEWa7PKZs&cart_link_id=Sy4dIPgn&preview_theme_id=160306823389" target="_top" rel="noopener" onClick={() => trackPixelEvent('InitiateCheckout', {
        content_name: 'CÓDIGO ACELERADO',
        value: 27990,
        currency: 'ARS'
      })} className="w-full bg-gold-primary text-black font-bold text-lg py-4 px-6 rounded-md shadow-gold hover:bg-gold-bright hover:shadow-gold-hover transition-all uppercase text-center block" data-id="element-192">
          🔴 → QUIERO EL CÓDIGO ACELERADO
        </a>
      </motion.div>
    </div>;
}